import React from 'react';
import { Modal } from 'react-bootstrap';
import ExternalImage from '../../common/components/ExternalImage';
import { injectIntl } from 'react-intl';
import backend from '../../../backend';

const GeometricElementStylePreviewModalWindow = ({ modalShow, hideModalWindow, styleName, layerType, ...props }) => {

    if (modalShow && styleName && layerType) {

        return (
            <Modal
                show={modalShow}
                size="xs" onHide={hideModalWindow}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {`${props.intl.formatMessage({ id: "project.elements.styles.show" })} ${styleName}`}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ExternalImage
                        className="d-block"
                        src={backend.elementService.geometricElementStylesPreviewURL(layerType, styleName)}
                        alt=""
                    />
                </Modal.Body>
            </Modal>
        );
    }

    return null;

}

export default injectIntl(GeometricElementStylePreviewModalWindow);